import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TaigaConfigService {
  constructor() { }

  removeAttributeGlobalStyle(): void {
    document.body.removeAttribute(
      'data-tui-theme',
    );
  }

}
